import React, { useEffect, useState } from 'react';
import {fetchBulkTransferRequests, fetchBulkTransferProcessTags } from './utils';
import DownloadTemplate from './DownloadTemplate';
import { bulkTransferTypes, EMPTY_FILTER_FORM } from './constants';
import UploadTransferFile from './UploadTranferFile';
import BulkTransferRequestsList from './BulkTransferRequestsList';
import Filters from './Filters';
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import ALoader from '../../../views/pages/manage/common/a-loader';
import { getAppliedFilterCount } from '../components/searchStudent/studentTransfersListing/utils';
import { useHistory } from 'react-router-dom';
import { useGetPermissions } from 'layouts/customHook';


const StudentBulkTransfer = ({
    userPermissions
}) => {

    const history = useHistory();

    const bulkTrasferForSTCGRegularPermission = (useGetPermissions("bulkTrasferForSTCGRegular")||[])?.includes("B");
    const bulkTrasferForCRCGRegularPermission = (useGetPermissions("bulkTrasferForCRCGRegular")||[])?.includes("B");
    const bulkTrasferForIBTRAcquisitionPermission = (useGetPermissions("bulkTrasferForIBTRAcquisition")||[])?.includes("B");
    const bulkTrasferForIBTRRegular = (useGetPermissions("bulkTrasferForIBTRRegular")||[])?.includes("B");
    
    // Map transfer type values to their corresponding permission flags
    const permissionMap = {
      'BULK_TRANSFER_FOR_STCG_REGULAR': bulkTrasferForSTCGRegularPermission,
      'BULK_TRANSFER_FOR_CRCG_REGULAR': bulkTrasferForCRCGRegularPermission,
      'BULK_TRANSFER_FOR_IBTR_ACQUISITION': bulkTrasferForIBTRAcquisitionPermission,
      'BULK_TRANSFER_FOR_IBTR_REGULAR': bulkTrasferForIBTRRegular,
    };

    const [permittedBulkTransferTypes, setPermittedBulkTransferTypes] = useState([]);
    const [bulkTransferRequests, setBulkTransferRequests] = useState({ loading: false, data: [] });
    const [paginationInfo, setPaginationInfo] = useState({
        currPageNo: 0,
        currPageSize: 50,
        totalRecords: 0
    })
    const [filterForm, setFilterForm] = useState(EMPTY_FILTER_FORM);
    const [loading, setLoading] = useState(false);


    const handleFilterForm = (key, val) => setFilterForm(prev => ({ ...prev, [key]: val }));

    const getBulkTransferRequestsList = async ({
        filters = filterForm,
        offset = paginationInfo?.currPageNo,
        pageSize = paginationInfo?.currPageSize,
    }) => {
        try {
            setBulkTransferRequests(prev => ({ ...prev, loading: true }));
            const resp = await fetchBulkTransferRequests({ filters, offset, pageSize });
            debugger
            const { totalRecords, records, currentPage } = resp?.data;
            setBulkTransferRequests(prev => ({ ...prev, data: records }));

            setPaginationInfo(prev => ({
                ...prev,
                totalRecords,
                currPageNo: currentPage,
                currPageSize: pageSize
            }))


            setFilterForm({
                ...filters,
                appliedFilterCount: getAppliedFilterCount(filters)
            });

        } catch (err) {
            console.error(err);
        } finally {
            setBulkTransferRequests(prev => ({ ...prev, loading: false }));

        }

    }

    const init = async () => {
        try {
            setLoading(true);
            const [allActiveProcessTags] = await Promise.all([fetchBulkTransferProcessTags(), getBulkTransferRequestsList({})]);

            // Build permitted list from active process tags (keep processTag objects)
            const list = (allActiveProcessTags || []).filter(processTag => {
                const key = processTag?.tagTypeKey;
                const hasPermission = permissionMap[key];
                const existsInBulkTypes = (bulkTransferTypes || []).some(t => t.value === key);
                return hasPermission && existsInBulkTypes;
            });
            setPermittedBulkTransferTypes(list);
            setLoading(false);
        }
        catch (err) {
            console.error(err);
            setLoading(false);
        }


    }

    useEffect(() => {
        init()
    }, [])


    return (
        <div className='a-card'>
            {loading && <ALoader position={"fixed"} zIndex={120} />}

            {/* card Header  */}
            <div className='d-flex justify-content-between mb-3'>

                <div className='d-flex align-items-center'>
                    <BackArrow className='mr-2 cursor' onClick={() => history.goBack()} />

                    <h3 className='mb-0'>Bulk Transfer</h3>
                </div>



                <div className='d-flex'>
                    <Filters
                        filterForm={filterForm}
                        handleFilterForm={handleFilterForm}
                        getBulkTransferRequestsList={getBulkTransferRequestsList}
                    />

                    <DownloadTemplate
                        permittedBulkTransferTypes={permittedBulkTransferTypes}
                    />

                    <UploadTransferFile
                        permittedBulkTransferTypes={permittedBulkTransferTypes}
                        setLoading={setLoading}
                        getBulkTransferRequestsList={getBulkTransferRequestsList}
                    />
                </div>
            </div>
            <BulkTransferRequestsList
                rows={bulkTransferRequests?.data || []}
                paginationInfo={paginationInfo}
                getBulkTransferRequestsList={getBulkTransferRequestsList}
            />

        </div>
    );
}

export default StudentBulkTransfer;